/* The Unlucky Cass — Scroll reveal animations */
(function () {
  'use strict';

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.style.getPropertyValue('--delay') || '0s';
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, parseFloat(delay) * 1000);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  function initReveal(root) {
    (root || document).querySelectorAll('.uc-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else {
    initReveal();
  }

  // Editor de temas: a seção é reinjetada no DOM e os elementos novos
  // ficariam presos em opacity 0. Dentro do editor, mostra direto.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.uc-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  });
})();
